import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./modules/Home";
import NotFound from "./modules/NotFound";
import AboutUs from "./modules/AboutUs";
import ContactUs from "./modules/ContactUs";
import Projects from "./modules/Projects";
import DevelopmentUpdates from "./modules/DevelopmentUpdates";
import DevelopmentUpdatesView from "./modules/DevelopmentUpdates/components/DevelopmentUpdatesView";
import ProjectDetails from "./modules/ProjectDetails";
import Ventures from "./modules/Ventures";
import VentureDetails from "./modules/VentureDetails";
import Layout from "./components/layout";
import PrivacyPolicy from "./modules/PrivacyPolicy";
import TermsOfService from "./modules/TermsOfService";

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route element={<Layout />}>
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/developments" element={<Projects />} />
        <Route path="/developments/:id" element={<ProjectDetails />} />
        <Route path="/development-updates" element={<DevelopmentUpdates />} />
        <Route
          path="/development-updates/:projectId"
          element={<DevelopmentUpdates />}
        />
        <Route
          path="/development-updates/view/:projectId"
          element={<DevelopmentUpdatesView />}
        />
        <Route path="/ventures" element={<Ventures />} />
        <Route path="/ventures/:id" element={<VentureDetails />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default App;
